var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.is_route)?_c('router-link',_vm._g({attrs:{"to":_vm.href,"target":_vm.target ? _vm.target : null,"rel":_vm.rel_value,"active-class":"active"}},_vm.$listeners),[_vm._t("default")],2):_c('a',_vm._g({attrs:{"href":_vm.href,"target":_vm.target ? _vm.target : null,"rel":_vm.rel_value}},_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }